import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import parse from 'html-react-parser';

import {Dropdown} from 'screens/commons';

const propTypes = {
  relationshipOptions: PropTypes.array.isRequired,
  selectedRelationship: PropTypes.object,
  onSelectRelationship: PropTypes.func.isRequired,
  isGuardianRelationship: PropTypes.bool.isRequired,
};

const RelationshipProofPrependContent = ({
  relationshipOptions,
  selectedRelationship,
  onSelectRelationship,
  isGuardianRelationship,
}) => {
  const dropdownOptions = relationshipOptions.map((option) => (
    <RelationshipOption
      key={option.key}
      className="body-small"
      onClick={() => onSelectRelationship(option)}
    >
      {parse(option.render)}
    </RelationshipOption>
  ));

  return (
    <>
      <SectionLabel className="body-small">Relationship with the Minor</SectionLabel>
      <Dropdown
        options={dropdownOptions}
        title={selectedRelationship?.render ? parse(selectedRelationship.render) : 'Select relationship'}
        size="small"
      />
      {isGuardianRelationship ? (
        <ProofLabel className="body-small">
          Proof of Relationship with the Minor
          <br />
          <span>(Please upload court-attested proof of legal guardian)</span>
        </ProofLabel>
      ) : null}
    </>
  );
};

const SectionLabel = styled.p`
  color: #7e7e7e;
  margin-bottom: 0.5rem;
  margin-top: 1.5rem;
`;

const ProofLabel = styled.p`
  color: #000000;
  margin-top: 1.5rem;
  margin-bottom: 0.75rem;
  font-weight: 500;

  span {
    color: #7e7e7e;
    font-weight: 400;
  }
`;

const RelationshipOption = styled.li`
  text-decoration: none;
  padding: 0.7rem;
  display: flex;
  align-items: center;
  color: ${(props) => props.theme.colors.text.secondary};
  cursor: pointer;
  transition: all 0.2s ease-in-out;
  font-size: ${(props) => props.theme.typography.fontSize.sm};
  line-height: 1.5;

  &:last-child {
    border-bottom: none;
  }

  &:hover {
    background-color: ${(props) => props.theme.colors.background.secondary};
    color: ${(props) => props.theme.colors.brand.primary};
  }
`;

RelationshipProofPrependContent.propTypes = propTypes;

export default RelationshipProofPrependContent;
